export const CREATE_CUSTOMER  = 'CREATE_CUSTOMER';
export const GET_CUSTOMERS  = 'GET_CUSTOMERS';
export const CUSTOMER_REQUEST  = 'CUSTOMER_REQUEST';
export const DELETE_CUSTOMER  = 'DELETE_CUSTOMER';
export const UPDATE_CUSTOMER  = 'UPDATE_CUSTOMER';
export const CUSTOMER_REQUEST_FAILURE  = 'CUSTOMER_REQUEST_FAILURE';